import axios from '../http'
import global from '@/constants/Global.constants'

export default {
    getMemberDetail(params) { // 获取订单详情
        return axios.post(global.CMC_DEALER + '/findByIdGetDealerInfo', params)
    },
    updateMemberInfo(params) { // 获取订单详情
        return axios.post(global.CMC_DEALER + '/updateDealer', params)
    },
    updatePass(params) {
        return axios.post(global.CMC_DEALER + '/updateDealerPassword', params)
    },
    insertRepair(params) {
        return axios.post(global.MSI_MIS + '/repair/insertRepair', params)
    },
    findAllRepairItem(params) {
        return axios.post(global.MSI_MIS + '/repair/findAllRepairItem', params)
    },
    updateRepair(params) { // 返修去付款保留状态
        return axios.post(global.MSI_MIS + '/repair/updateRepair', params)
    },
}


// WEBPACK FOOTER //
// ./src/request/member/member.js